// One background per Jalaali month, following the seasons: spring greens,
// summer heat, autumn earth, winter blues — closing the circle back toward
// spring. All dark enough for white text (WCAG-friendly at ~24–30% lightness).
//
// Channel lists rather than colors, because this feeds --paper-rgb: the
// seasons theme makes the month's own color the paper the calendar sits on,
// and components dial their own alpha off it. The HSL each came from is kept
// alongside — that is the form they were picked in.
export const J_MONTH_COLORS = [
    '48, 83, 68', //'50, 133, 99', // hsl(155, 45%, 36%) فروردین — spring green
    '54, 85, 55', //'60, 134, 66', // hsl(125, 38%, 38%) اردیبهشت — full bloom
    '74, 84, 55',//'108, 131, 63', // hsl(80, 35%, 38%) خرداد — yellow-green, early heat
    '104, 81, 48', //'171, 118, 43', // hsl(35, 60%, 42%) تیر — golden sun
    '106, 63, 49', //'177, 80, 47', // hsl(15, 58%, 44%) مرداد — high summer
    '96, 49, 63', // #60313f شهریور — late-summer red
    '88, 64, 47', //'145, 89, 48', // hsl(25, 50%, 38%) مهر — amber leaves
    '77, 50, 46', //'125, 65, 54', // hsl(10, 40%, 35%) آبان — rust
    '75, 52, 67', //'118, 66, 100', // hsl(320, 28%, 36%) آذر — plum dusk
    '62, 56, 89', //'82, 70, 145', // hsl(250, 35%, 42%) دی — winter violet
    '53, 64, 88', //'61, 88, 143', // hsl(220, 40%, 40%) بهمن — cold blue
    '55, 80, 83', //'63, 125, 131', // hsl(185, 35%, 38%) اسفند — thawing teal
]

// The seasonal color of a month in the given system. Gregorian months are
// shifted so each maps to the Jalaali month sharing its season (April ≈ فروردین)
// — the same mapping the panorama uses to pick a month's frame.
export const monthColor = (month: number, system: 'jalaali' | 'gregorian') =>
    J_MONTH_COLORS[system === 'gregorian' ? (month + 8) % 12 : month - 1]

// The flat themes' paper and ink, as --paper-rgb and --ink-rgb channel lists,
// and the color a holiday number is written in. Mirrors the theme blocks in
// app/public/index.html by hand, the way theme.ts already mirrors --paper for
// the browser chrome: the home-screen widget draws in a launcher process with
// no stylesheet, so anything it paints has to reach it as a value.
//
// The seasons theme is not here. Its paper is whichever month the day falls
// in, so it comes from monthColor above, and its ink is white.
export const THEME_COLORS = {
    // The two with art take the sky off the top of their own painting, so the
    // page and the picture meet with nothing between them. Measured from the
    // images, which are flat to within two levels across the whole year.
    light: { paper: '207, 223, 221', ink: '42, 42, 42', holiday: '184, 64, 47' },
    dark: { paper: '0, 18, 51', ink: '233, 238, 247', holiday: '255, 155, 131' },
    // The two without: the same calendar on plain paper, which is what the
    // light and dark themes were before the panorama came back.
    paper: { paper: '244, 239, 228', ink: '42, 42, 42', holiday: '184, 64, 47' },
    slate: { paper: '49, 55, 63', ink: '233, 238, 247', holiday: '255, 155, 131' },
}
